export default __webpack_public_path__ + "static/media/image.8a9d880b.png";